import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x="19" y="11.244" width="1.512" height="14" rx=".756" transform="rotate(90 19 11.244)" fill="currentColor" /><rect x="11.283" y="5" width="1.434" height="14" rx=".717" fill="currentColor" /></svg>);